import React, { useState, useRef } from 'react';
export function TestimonialCarousel() {
  const testimonials = [{
    quote: "I'd accepted that this was just what happened after my second baby. After three sessions I have more hair than I did at 30.",
    author: 'Patient, San Ramon CA'
  }, {
    quote: 'The shedding stopped completely by my second treatment. Now, my part is noticeably tighter and my confidence is back.',
    author: 'Patient, Walnut Creek CA'
  }, {
    quote: "It's completely natural. No one knows I had anything done, they just keep asking what new shampoo I'm using.",
    author: 'Patient, Danville CA'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    if (isLeftSwipe) {
      setCurrentIndex(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
    }
    if (isRightSwipe) {
      setCurrentIndex(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
    }
    setTouchStart(0);
    setTouchEnd(0);
  };
  return <section className="bg-cream py-24 md:py-32 px-4 overflow-hidden" data-id="element-143">
      <div className="max-w-4xl mx-auto text-center relative" data-id="element-144">
        <div className="text-gold text-6xl md:text-8xl font-serif leading-none mb-8 opacity-40 select-none" aria-hidden="true" data-id="element-145">
          "
        </div>

        <div className="relative" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-146">
          <div className="overflow-hidden" data-id="element-147">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-148">
              {testimonials.map((t, idx) => <div key={idx} className="w-full flex-shrink-0 px-4" data-id="element-149">
                  <blockquote className="font-serif italic text-2xl md:text-4xl text-espresso leading-relaxed mb-8" data-id="element-150">
                    {t.quote}
                  </blockquote>
                  <cite className="font-sans text-base md:text-lg text-muted-foreground not-italic uppercase tracking-wider" data-id="element-151">
                    — {t.author}
                  </cite>
                </div>)}
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center space-x-3 mt-12" data-id="element-152">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors duration-300 ${currentIndex === idx ? 'bg-gold' : 'bg-divider hover:bg-gold/50'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-153" />)}
        </div>
      </div>
    </section>;
}